import { WebApiRequest, HTTP_GET, HTTP_PUT, HTTP_POST } from "tools/webservice";
import { CaseFollowUpUpdateRequest, CaseFollowUpInsertRequest, CaseFollowUpDto } from "interfaces/Mueller.Business.Models";

export const getCaseFollowUp = (controlIdNumber: number, successCallback: (data: CaseFollowUpDto) => void, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/case-follow-ups/cases/${controlIdNumber}`,
  successCallback,
  mountedRef,
});

export const updateCaseFollowUp = (caseFollowUpId: number, request: CaseFollowUpUpdateRequest, successCallback: () => void, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/case-follow-ups/${caseFollowUpId}`,
  payload: request,
  successCallback,
  mountedRef,
});

export const insertCaseFollowUp = (request: CaseFollowUpInsertRequest, successCallback: () => void, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/case-follow-ups`,
  payload: request,
  successCallback,
  mountedRef,
});

export const completeCaseFollowUp = (caseFollowUpId: number, successCallback: () => void, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/case-follow-ups/${caseFollowUpId}/complete`,
  successCallback,
  mountedRef,
});